import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import SwapCallsIcon from '@mui/icons-material/SwapCalls'
import fromExponential from 'from-exponential'
import Connection from '../../../Deposite'
import BscContract from '../../../Contract'
import bigInt from 'big-integer'
import Web3 from 'web3'
import Web3Token from 'web3-token'
import axios from 'axios'
import web3Object from '../../../utils'
import { ToastContainer, toast } from 'react-toastify'
import rewardRegisterContract from '../../../AllContract/RewardRegisterContract'
import { useWeb3Context } from '../../../hooks/web3Context'

const ContractClaimReward = () => {
  const [contractAddress, setContractAddress] = React.useState('')
  const [ownerAddress, setOwnerAddress] = React.useState('')
  let [account, setAccount] = useState('')
  const [claimBalance, setClaimBalance] = useState('0')

  const web3 = new Web3()
  web3.setProvider(window.ethereum)

  const getAccounts = async () => {
    if (typeof window !== undefined) {
      try {
        account = await window.ethereum.selectedAddress
        // setAccount(account);
        console.log('printing account in get account : ', account)
      } catch (error) {
        // console.log(error);
      }
    }
  }

  if (typeof window !== undefined) {
  }

  useEffect(() => {
    getAccounts()
    getAbc()
  }, [])

  useEffect(() => {
    getClaimBalance()
    return () => {}
  }, [account])

  const getClaimBalance = async () => {
    try {
      let balance = await rewardRegisterContract.rewardAmountOwner(account)
      let formatToEther = web3.utils.fromWei(balance.toString())
      setClaimBalance(formatToEther)
    } catch (error) {
      console.log(error)
    }
  }

  async function getAbc() {
    try {
      let web3 = new Web3(window.ethereum)
      let ch = await web3.eth.getAccounts()
      console.log('web3', ch)
      setAccount(ch[0])
      setOwnerAddress(ch[0])
      getClaimBalance()
    } catch (error) {}
  }

  const handleRegisterContract = async () => {
    console.log('handleRegisterContract', BscContract)

    try {
      let callMethod = await BscContract.claimOwnerReward()
      let waitForTransaction = await callMethod.wait()
      if (waitForTransaction) {
        toast.success('Transaction Done')
        getClaimBalance()
      }
      console.log('check metjhod')
    } catch (error) {
      try {
        if (error.data) {
          toast.error(error.error.data.message)
        } else {
          toast.error('Execution reverted')
        }
      } catch (error) {
        console.log('error', error)
      }
    }
    // registerContract(account);
  }

  return (
    <>
      <ToastContainer />

      <div
        className="stack_modal"
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          marginTop: '24px',
        }}
      >
        <Card className="section-card">
          <Box sx={{ flexGrow: 1, width: '100%' }}>
            <Typography className="header-text">Claim Reward</Typography>
            <Grid container pt={1} px={2}>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <Typography>Owner Address</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <TextField
                  size="small"
                  hiddenLabel
                  variant="filled"
                  value={ownerAddress ? ownerAddress : 'Connect wallet'}
                  disabled
                  // onChange={(e) => setOwnerAddress(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Grid container pt={1} px={2}>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <Typography>Claim Balance</Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <Typography>
                  {claimBalance ? claimBalance : '0.000'} DXT
                </Typography>
              </Grid>
            </Grid>

            <Grid container pt={1} px={2}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <Button
                  variant="contained"
                  sx={{
                    mt: 1,
                  }}
                  onClick={handleRegisterContract}
                  size="large"
                >
                  Claim Reward
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </div>
    </>
  )
}

export default ContractClaimReward
